module.exports = __webpack_public_path__ + "img/upload_info_l.c3ccd19a.svg";